export default "__VITE_ASSET__430b4963__"